<script setup lang="ts">
// import { useHead } from '@vueuse/core'
// import UpgradeToPro from '@/components/UpgradeToPro.vue'
// import AdsDetailsLayout from '@/pages/ads-details-layouts.vue'
const title = ref('AgroTrade Marketplace')

</script>

<template>
  <Head>
    <Title>{{ title }}</Title>
    <Meta
      name="description"
      content="AgroTrade Marketplace is Nigeria's No. 1 leading Agricultural Ads Store that brings farmers and sellers together on one platform, not limited by distance. We do not get involved with transactions made between buyers and sellers."
    />
  </Head>
  <VApp>
    <!-- Responsive App Layout -->
    <VMain class='v-main'>
      <VContainer fluid='' class="pa-0 v-container">
        <RouterView />
      </VContainer>
    </VMain>
<!--    <UpgradeToPro />-->
  </VApp>
</template>

<style>
/* Global styles for responsiveness */
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden; /* Prevent horizontal scrolling */
}

/* Ensure VContainer and VMain are responsive */
.v-container {
  max-width: 100% !important;
  padding: 0 !important;
}

.v-main {
  padding: 0 !important;
}
</style>
